import { Field, Formik } from "formik";
import React, { useState } from "react";
import { Input, Select } from "../../../../../../_metronic/_partials/controls";
import * as Yup from "yup";
import { genOptionLoaderParams } from "../../../../../../_metronic/_helpers/fetchUtils";
import { findorganization } from "../../../_redux/organization/organizationCrud";
import AsyncSelect from "react-select/async";
import { NOTIFICATION_ORGANIZATION_TYPES_ARRAY } from "../OrganizationClassificationUIHelpers";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { utc_minutes_offset } from "../../../../../../_metronic/_helpers/time-helpers";

const validationSchema = Yup.object({
  name: Yup.string().required("Nama tidak boleh kosong!"),
  dd_fund: Yup.string().required("Dana DD tidak boleh kosong!"),
  program_fund: Yup.string().required("Program Bersama tidak boleh kosong!"),
  utilization_fund: Yup.string().required(
    "Dana Pendayagunaan tidak boleh kosong!"
  )
});

export default function OrganizationClassificationCreateForm({
  onSubmit,
  defaultValues,
  onHide
}) {
  return (
    <Formik
      initialValues={defaultValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize={true}
    >
      {({ setFieldValue, handleSubmit, values }) => (
        <>
          <div className="form-group row">
            <div className="col">
              <Field
                name="name"
                label="Nama"
                component={Input}
                value={values.name}
                placeholder="Lembaga diatas 1 Miliar"
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col">
              <label>
                <strong>
                  Dana DD
                  {values.dd_fund && (
                    <span className="mx-2">{`(${values.dd_fund}%)`}</span>
                  )}
                </strong>
              </label>
              <Field
                name="dd_fund"
                component={Input}
                type="number"
                value={values.dd_fund}
                placeholder="Cth: 5%"
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col">
              <label>
                <strong>
                  Dana Program Bersama
                  {values.program_fund && (
                    <span className="mx-2">{`(${values.program_fund}%)`}</span>
                  )}
                </strong>
              </label>
              <Field
                name="program_fund"
                component={Input}
                type="number"
                value={values.program_fund}
                placeholder="Cth: 5%"
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col">
              <label>
                <strong>
                  Dana Pendayagunaan
                  {values.utilization_fund && (
                    <span className="mx-2">
                      {`(${values.utilization_fund}%)`}
                    </span>
                  )}
                </strong>
              </label>
              <Field
                name="utilization_fund"
                component={Input}
                type="number"
                value={values.utilization_fund}
                placeholder="Cth: 0.05 = 5%"
              />
            </div>
          </div>
          <button
            className="btn btn-primary float-right mx-1"
            onClick={handleSubmit}
          >
            Simpan
          </button>
          <button
            className="btn btn-secondary float-right mx-1"
            onClick={onHide}
          >
            Tutup
          </button>
        </>
      )}
    </Formik>
  );
}
